Math.log10 = Math.log10 || function (x) {
	return Math.log(x) * Math.LOG10E;
};

module.exports = {};
